import type { MarkerInfo } from '@mimir/primitive/premiere/premiereInfo';
import { premiereMarkerColors } from '@mimir/client-common/util/premiere';
import { getTimedMetadata } from '../util/api';
import { mdfState } from '@mimir/web/globals/mdfState';

export async function getMarkers(itemId: string, subclipStart: number | undefined, subclipEnd: number | undefined) {
  const timedMetadataCollection = await getTimedMetadata(itemId);
  const markers: MarkerInfo[] = [];
  timedMetadataCollection.items.forEach(entry => {
    if (!entry.data.formId) {
      return;
    }

    const mdf = mdfState.state.getMdfById(entry.data.formId);
    if (!mdf || !mdf.compatibleWithPremiereMarker) {
      return;
    }

    const markerName = entry.data.generated_description || mdf.label;
    if (!markerName) {
      return;
    }

    if (subclipStart !== undefined) {
      if (entry.endMs <= subclipStart) {
        return;
      }
      if (entry.startMs < subclipStart) {
        entry.startMs = subclipStart;
      }

      if (subclipEnd !== undefined) {
        if (entry.startMs >= subclipEnd) {
          return;
        }
        if (entry.endMs > subclipEnd) {
          entry.endMs = subclipEnd;
        }
      }

      entry.startMs -= subclipStart;
      entry.endMs -= subclipStart;
    }

    const colorIndex = premiereMarkerColors.findIndex(color => mdf.color === color);

    const marker = {
      name: markerName,
      start: entry.startMs > 0 ? entry.startMs / 1000 : 0,
      end: entry.endMs > 0 ? entry.endMs / 1000 : 0,
      colorIndex: colorIndex >= 0 ? colorIndex : 0,
    };

    markers.push(marker);
  });

  return markers;
}
